export default __webpack_public_path__ + "static/media/boxicons.092b7858.eot";